<ng-container>
  <div mat-dialog-title>
    <h2>{{"restaurant.Set Exception Rule (No. of Reservation)" | translate}}</h2>
    <button mat-icon-button class="close" (click)="openConfirmDialog()">
      <mat-icon class="pop-close">close</mat-icon>
    </button>
  </div>
  <form [formGroup]="formGroup">
    <mat-dialog-content class="pt-0 pb-0">
      <div class="mat-dialog-body">
        <p class="info">{{"restaurant.Except guests who booked this no.of reservation (all the time)" | translate}}</p>
        <div class="fields-group mt-3">
          <mat-form-field class="mb-2">
            <mat-label>{{"restaurant.No. of Reservation" | translate}}</mat-label>
            <input matInput formControlName="reservationNumber" maxlength="10" appOnlynumber>
            <mat-error *ngIf="hasError('reservationNumber', 'required')">{{ 'forms.Required' | translate }}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button class="btn-grey" (click)="openConfirmDialog()">{{"forms.Cancel" | translate}}</button>
      <!-- [disabled]="loading" [class.loading]="loading" *ngIf="isUpdate" -->
      <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
        {{"forms.Save" | translate}}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>
